import { useAuth } from "@/hooks/useAuth";
import NexusDashboard from "@/components/NexusDashboard";
import EmployeeStockView from "@/components/EmployeeStockView";

const Index = () => {
  const { role, isFounder } = useAuth();

  if (role === "admin" || isFounder) return <NexusDashboard />;
  return <EmployeeStockView />;
};

export default Index;
